module.exports = __webpack_public_path__ + "06a2c52f17501f73b9a5204d480abafb.pdf";